import React from 'react';
import useTranslate from '../../../customHooks/useTranslate';

interface LabelProps {
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
    className?: string;
    text?: string;
    translated?: boolean;
    children?: React.ReactNode;
}

const Label = (props: LabelProps) => {
    const {
        as: Component = 'h6',
        className,
        text,
        translated = true,
        children,
    } = props;
    const translatedText = useTranslate(text);
    return (
        <Component
            className={`property__label text-overflow-ellipsis ${
                className || ''
            }`}
        >
            {translated ? translatedText : text}
            {children}
        </Component>
    );
};

export default Label;
